import { Injectable } from '@angular/core';
import { IntercomService } from '../services/intercom.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { SessionService } from '@monsido/core/session/session.service';
import { IntercomProvider } from '../provider/intercom.provider';
import { EventsType } from '@monsido/services/mon-event/events.type';
import { chatSystems } from '@monsido/core/constants/general.constant';
import { ExtensionService } from '@client/app/modules/extension/services/extension.service';

interface IntercomConfig {
    app_id: string;
    custom_launcher_selector: string;
    hide_default_launcher: boolean;
    email?: string;
    name?: string;
    user_id?: number;
    user_hash?: string;
    have_extension_installed?: boolean;
}

interface IntercomSettings {
    company: {
        id: number;
        name: string;
    };
}

@Injectable({
    providedIn: 'root',
})
export class IntercomRunService {
    constructor (
        private intercomService: IntercomService,
        private monEventService: MonEventService,
        private intercomProvider: IntercomProvider,
        private extensionService: ExtensionService,
        private sessionService: SessionService,
    ) {}

    public setupEventListeners (): void {
        this.monEventService.addListener('afterCustomer' as EventsType, () => {
            if (this.sessionService.isSudo) {
                this.intercomService.shutdown();
                return;
            }

            this.intercomProvider.addScript();
            const interComObj: IntercomConfig = {
                app_id: chatSystems.intercom.intercomId,
                custom_launcher_selector: '.mon_intercom_link',
                hide_default_launcher: true,
            };

            this.extensionService.isInstalled()
                .then((res: boolean) => {
                    if (this.sessionService.me) {
                        interComObj.email = this.sessionService.me.email;
                        interComObj.name = this.sessionService.me.getName();
                        interComObj.user_id = this.sessionService.me.id;
                        if (this.sessionService.me.intercom_user_hash) {
                            interComObj.user_hash = this.sessionService.me.intercom_user_hash;
                        }
                        interComObj.have_extension_installed = res;
                    }

                    this.intercomService.boot(interComObj);

                    const agreement = this.sessionService.agreement;
                    if (agreement?.account) {
                        const intercomSettings: IntercomSettings = {
                            company: {
                                id: agreement.account.id,
                                name: agreement.account.name,
                            },
                        };
                        this.intercomService.update(intercomSettings);
                    }
                })
                .catch(() => {
                    if (this.sessionService.me) {
                        interComObj.email = this.sessionService.me.email;
                        interComObj.name = this.sessionService.me.getName();
                        interComObj.user_id = this.sessionService.me.id;
                        if (this.sessionService.me.intercom_user_hash) {
                            interComObj.user_hash = this.sessionService.me.intercom_user_hash;
                        }
                    }
                    this.intercomService.boot(interComObj);
                });

            if (this.sessionService.getChatSystem() === 'intercom') {
                this.intercomService.onUnreadCountChange((count) => {
                    if (count > 0) {
                        this.monEventService.run('intercomUnread' as EventsType, count);
                    }
                });
            }

            this.monEventService.addListener('transitionsOnSuccess' as EventsType, (msg: string) => {
                this.intercomService.update();
            });

            this.intercomService.onHide(() => {
                this.monEventService.run('intercomHide' as EventsType);
            });

            this.intercomService.onShow(() => {
                this.monEventService.run('intercomShow' as EventsType);
            });

            this.monEventService.addListener('logout' as EventsType, () => {
                this.intercomService.shutdown();
            });
        });
    }
}
